let inject = [
  '$scope',
  'ReportOrdersService',
  '$state',
  '$rootScope',
  'SharedService',
  '$timeout',
  'ngAuthSettings',
  'CartService',
  'SessionService',
  'NgTableParams',
  '$uibModal',
  '$filter'
];

class ReportOrdersController{
  constructor ($scope,
               ReportOrdersService,
               $state,
               $rootScope,
               SharedService,
               $timeout,
               ngAuthSettings,
               CartService,
               SessionService,
               NgTableParams,
               $uibModal,
               $filter) {
    this.$state = $state;
    this.SessionService = SessionService;
    this.ngAuthSettings = ngAuthSettings;
    this.CartService = CartService;
    this.$filter = $filter;
    // this.$scope = $scope;
    this.$timeout = $timeout;
    this.$rootScope = $rootScope;
    this.NgTableParams = NgTableParams;
    this.ReportOrdersService = ReportOrdersService;
    this.$uibModal = $uibModal;
    this.SharedService = SharedService;
  
    this.orders = null;
    this.state = {};
    this.branches = [];
  
    this.stateOrder = {};
    this.orderSelected = null;
    this.watchingOrder = false;
  
    // ngTable Params
    this.ngTableConfigOrder = null;
    this.ngTableColsOrder = null;
  
    this.totalValueToPayOrders = 0;
    this.totalValuePendingOrders = 0;
    this.updatedAt = '';
  
    // ngTable Params
    this.ngTableConfig = null;
    this.ngTableCols = null;
    this.thirdSelected = null;
    this.branchesSelected = null;
  }
  
  $onInit(){
    if(!this.shCtrl.globals.currentClient) this.shCtrl.globals.currentClient = {};
    if(!this.shCtrl.globals.currentClient.third) return;
    if(!this.shCtrl.globals.currentClient.third.documentNumber) return;
    this.getOrderStates();
  }
  
  getBranches(item){
    this.ReportOrdersService.getBranchesByThirdId(item.id).then(response =>{
      this.branches = response;
    });
  }
  
  getOrderStates(manual) {
    let documentNumber = '';
    let branchCode = '';
    try{
      if(manual){
        this.orders = [];
        documentNumber = this.thirdSelected.nit;
        if(angular.isArray(this.branchesSelected)){
          branchCode = this.branchesSelected;
        } else if(this.branchesSelected){
          branchCode = [this.branchesSelected.id];
        } else {
          branchCode = [];
        }
        
      } else {
        documentNumber = this.shCtrl.globals.currentClient.third.documentNumber;
        branchCode = this.shCtrl.globals.currentClient.operatingCenter.code;
      }
    }
    catch(e){
      return;
    }
    
    if(!documentNumber || !branchCode) {
      alert('Para realizar la consulta se necesita el numero de documento y el codigo de la sucursal.');
    }
    else {
      this.state = {};
      this.state.loading = true;
      if(manual){
        this.ReportOrdersService.getOrderStatesBranches(documentNumber, branchCode, this.fecha_ini, this.fecha_fin).then(orders => {
          this.state.loading = false;
          this.state.loaded = true;
          
          this.totalValueToPayOrders = 0;
          this.totalValuePendingOrders = 0;
          
          angular.forEach(orders, (order) => {
            let valor_pagar = +order.valor_pagar;
            let valor_pendiente = +order.valor_pendiente;
            
            this.totalValueToPayOrders    = this.totalValueToPayOrders + valor_pagar;
            this.totalValuePendingOrders  = this.totalValuePendingOrders + valor_pendiente;
          });
          
          this.orders = orders;
          this.initNgTable();
          
          this.updatedAt = this.$filter('date')(new Date(),'yyyy-MM-dd HH:mm:ss');
        }).catch(error => {
          this.state.loading = false;
          this.state.error = true;
        });
      } else {
        this.ReportOrdersService.getOrderStates(documentNumber, branchCode)
          .then(orders => {
            this.state.loading = false;
            this.state.loaded = true;
            
            this.totalValueToPayOrders = 0;
            this.totalValuePendingOrders = 0;
            
            angular.forEach(orders, order => {
              let valor_pagar = +order.valor_pagar;
              let valor_pendiente = +order.valor_pendiente;
              
              this.totalValueToPayOrders    = this.totalValueToPayOrders + valor_pagar;
              this.totalValuePendingOrders  = this.totalValuePendingOrders + valor_pendiente;
            });
            
            this.orders = orders;
            this.initNgTable();
            
            this.updatedAt = this.$filter('date')(new Date(),'yyyy-MM-dd HH:mm:ss');
          })
          .catch((error) => {
            this.state.loading = false;
            this.state.error = true;
          });
      }
    }
  }
  
  selectOrder (orderSelected) {
    this.watchingOrder = true;
    this.stateOrder.loading = true;
    let documentNumber = '';
    let branchCode = '';
    let nit = '';
    try {
      nit = this.thirdSelected.nit;
    } catch (e){}
    if(nit){
      documentNumber = this.thirdSelected.nit;
      if(angular.isArray(this.branchesSelected)){
        branchCode = this.branchesSelected;
      } else if(this.branchesSelected){
        branchCode = [this.branchesSelected.id];
      } else {
        branchCode = [];
      }
      
    } else {
      documentNumber = this.shCtrl.globals.currentClient.third.documentNumber;
      branchCode = this.shCtrl.globals.currentClient.operatingCenter.code;
    }
    this.ReportOrdersService.getOrderState(documentNumber, orderSelected.pedido_id)
      .then((order) => {
        this.stateOrder.loading = false;
        this.stateOrder.loaded = true;
        this.orderSelected = order;
        this.initNgTableOrder();
      }).catch((error) => {
      this.stateOrder.loading = false;
      this.stateOrder.loaded = true;
      this.stateOrder.error = true;
    });
  }
  
  blurOrder() {
    this.orderSelected = null;
    this.watchingOrder = false;
  }
  
  initNgTableOrder() {
    /**
     * destino:                             "ORDEN DE COMPRA 30455 **23183** LO RECOGEN"
     * fecha_pedido:                  (OK)  "2016-07-18 00:00:00"
     * id:                                  248
     * item_cantidad_despachada:      (OK)  0
     * item_cantidad_pedida:          (OK)  4
     * item_centro_operacion_pedido:        1
     * item_descripcion:              (OK)  "TRIAGE CARDIAC PANEL X 25 PBS"
     * item_estado:                   (OK)  null
     * item_fecha_entrega:            (OK)  "2016-07-18 00:00:00"(OK)
     * item_referencia:               (OK)  "97000HSEU"
     * item_unidad_medida:            (OK)  "UND"
     * item_valor_descuento:          (OK)  0
     * item_valor_total:              (OK)  1800000
     * item_valor_unitario:           (OK)  450000
     * pedido_estado:                       "1"
     * pedido_id:                           "PV-150296"
     * sucursal:                            "ANGEL DIAGNOSTICA S A/CAMBULOS"
     * sucursal_id:                         "01"
     * tercero:                             "ANGEL DIAGNOSTICA S A"
     * tercero_id:                          "805013591"
     * valor_pagar:                         null
     * valor_pendiente:                     null
     * vendedor:                            "ALVAREZ ACHURY CONSTANZA VIVIANA"
     * vendedor_id:                         "0231"
     */
    
    this.ngTableColsOrder = [
      {
        field: "fecha_pedido",
        title: "Fecha Pedido",
        sortable: "fecha_pedido",
        filter: { "fecha_pedido": "text" },
        show: true
      },
      {
        field: "item_fecha_entrega",
        title: "Fecha Entrega",
        sortable: "item_fecha_entrega",
        filter: { "item_fecha_entrega": "text" },
        show: true
      },
      {
        field: "item_referencia",
        title: "Ref.",
        sortable: "item_referencia",
        filter: { "item_referencia": "text" },
        show: true
      },
      {
        field: "item_descripcion",
        title: "Descripción",
        sortable: "item_descripcion",
        filter: { "item_descripcion": "text" },
        show: true
      },
      {
        field: "item_estado",
        title: "Estado ítem",
        sortable: "item_estado",
        filter: { "item_estado": "text" },
        show: true
      },
      {
        field: "item_unidad_medida",
        title: "Und. de Medida",
        sortable: "item_unidad_medida",
        filter: { "item_unidad_medida": "text" },
        show: true
      },
      {
        field: "item_cantidad_pedida",
        title: "Cant. Pedida",
        sortable: "item_cantidad_pedida",
        filter: { "item_cantidad_pedida": "text" },
        show: true
      },
      // {
      //   field: "item_cantidad_despachada",
      //   title: "Cant. Despachada",
      //   sortable: "item_cantidad_despachada",
      //   filter: { "item_cantidad_despachada": "text" },
      //   show: true
      // },
      // {
      //   field: "item_cantidad_pendiente",
      //   title: "Cant. Pendiente",
      //   sortable: "item_cantidad_pendiente",
      //   filter: { "item_cantidad_pendiente": "text" },
      //   show: true
      // },
      {
        field: "item_valor_unitario",
        title: "Vr. Uni. Antes Iva",
        sortable: "item_valor_unitario",
        filter: { "item_valor_unitario": "text" },
        show: true
      },
      {
        field: "item_valor_descuento",
        title: "Vr. Dscto. Comercial",
        sortable: "item_valor_descuento",
        filter: { "item_valor_descuento": "text" },
        show: true
      },
      {
        field: "item_valor_total",
        title: "Vr. Neto Antes Iva",
        sortable: "item_valor_total",
        filter: { "item_valor_total": "text" },
        show: true
      }
    ];
    
    let initialParams = {
      count: 20,
      sorting: { item_fecha_entrega: "desc" }
    };
    
    let initialSettings = {
      counts: [5, 10, 20],
      paginationMaxBlocks: 8,
      paginationMinBlocks: 2,
      dataset: this.orderSelected
    };
    
    this.ngTableConfigOrder = new this.NgTableParams(initialParams, initialSettings);
  }
  
  initNgTable() {
    
    this.ngTableCols = [
      {
        field: "pedido_id",
        title: "Pedido",
        sortable: "pedido_id",
        filter: { "pedido_id": "text" },
        show: true
      },
      {
        field: "pedido_estado",
        title: "Estado",
        sortable: "pedido_estado",
        filter: { "pedido_estado": "text" },
        show: true
      },
      {
        field: "fecha_pedido",
        title: "Fecha del Pedido",
        sortable: "fecha_pedido",
        filter: { "fecha_pedido": "text" },
        show: true
      },
      {
        field: "fecha_actualizacion",
        title: "Fecha Ultima Actualización",
        sortable: "fecha_actualizacion",
        filter: { "fecha_actualizacion": "text" },
        show: true
      },
      {
        field: "sucursal",
        title: "Punto de Envío",
        sortable: "sucursal",
        filter: { "sucursal": "text" },
        show: true
      },
      {
        field: "vendedor",
        title: "Vendedor",
        sortable: "vendedor",
        filter: { "vendedor": "text" },
        show: true
      },
      {
        field: "valor_pagar",
        title: "Vr. Antes Iva",
        sortable: "valor_pagar",
        filter: { "valor_pagar": "text" },
        show: true
      },
      {
        field: "valor_pendiente",
        title: "Valor Neto Pendiente",
        sortable: "valor_pendiente",
        filter: { "valor_pendiente": "text" },
        show: true
      },
      {
        field: "actions",
        title: "Detalle",
        show: true
      },
    ];
    
    let initialParams = {
      count: 20,
      sorting: { item_fecha_entrega: "desc" }
    };
    
    let initialSettings = {
      counts: [5, 10, 20],
      paginationMaxBlocks: 8,
      paginationMinBlocks: 2,
      dataset: this.orders
    };
    
    this.ngTableConfig = new this.NgTableParams(initialParams, initialSettings);
  }
  
  
}

ReportOrdersController.$inject = inject;

export default ReportOrdersController;




// WEBPACK FOOTER //
// ./www/components/reports/orders/orders.controller.js